import API_URLS from '@Constants/apiUrls.constants';
import {
  SMTPSettingsAdd,
  SMTPSettingsEdit,
  SMTPSettingsResponse,
  SMTPSettingsVerifyToken,
} from '@Models/smtpSettings.models';

import { baseApi } from './baseApi.service';

export const smtpSettingsApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['SMTPSettings'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getSMTPSettings: builder.query<
        SMTPSettingsResponse,
        string | number | null
      >({
        query: (accountId) => ({
          url: `${API_URLS.SMTP_SETTINGS.BASE}/`,
          params: {
            accountId,
          },
        }),
        providesTags: ['SMTPSettings'],
      }),
      addSMTPSettings: builder.mutation<void, SMTPSettingsAdd>({
        query: (body) => ({
          url: `${API_URLS.SMTP_SETTINGS.BASE}`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['SMTPSettings'],
      }),
      editSMTPSettings: builder.mutation<void, SMTPSettingsEdit>({
        query: (body) => ({
          url: `${API_URLS.SMTP_SETTINGS.BASE}/${body.id}`,
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['SMTPSettings'],
      }),
      sendSMTPSettingsVerificationEmail: builder.mutation<void, void>({
        query: () => ({
          url: `${API_URLS.SMTP_SETTINGS.VERIFICATION_SEND}`,
          method: 'POST',
        }),
      }),
      verifySMTPSettings: builder.mutation<void, SMTPSettingsVerifyToken>({
        query: (body: SMTPSettingsVerifyToken) => ({
          url: `${API_URLS.SMTP_SETTINGS.VERIFY_TOKEN}`,
          method: 'POST',
          body,
        }),
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetSMTPSettingsQuery,
  useAddSMTPSettingsMutation,
  useEditSMTPSettingsMutation,
  useSendSMTPSettingsVerificationEmailMutation,
  useVerifySMTPSettingsMutation,
} = smtpSettingsApi;
